import React from 'react'

import CallToUsButton from '../../components/CallToUsButton/CallToUsButton'
import MapComponent from '../../components/MapComponent/MapComponent'
import { CloseIcon } from '../../utils/icons'
import Modal from '../Modal/Modal'
import {
  closeIcon,
  container,
  modalHeading,
  modalInfo,
  modalMap,
  modalSection,
} from './MapModal.module.css'

const MapModal = ({ contactData, isOpen, locationData, onClose }) => {
  const { addresslabel, addresstext, emailaddress, emaillabel } = locationData

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={container}>
        <div className={modalMap}>
          <MapComponent />
        </div>
        <div className={modalInfo}>
          <div className={modalHeading}>
            <h3>{addresslabel}</h3>
            <div onClick={onClose} role="presentation">
              <CloseIcon className={closeIcon} />
            </div>
          </div>
          <div className={modalSection}>
            <p>{addresstext}</p>
            <h3>{emaillabel}</h3>
            <a href={`mailto:${emailaddress}`}>{emailaddress}</a>
          </div>
          <CallToUsButton cta={contactData} />
        </div>
      </div>
    </Modal>
  )
}

export default MapModal
